import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

export const button3DVariants = cva(
  "inline-flex items-center justify-center rounded-full font-bold text-sm transition-all duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2",
  {
    variants: {
      variant: {
        primary:
          "bg-brand-deep text-white hover:bg-brand-deep/90 active:bg-brand-deep/95",
        accent:
          "bg-brand-accent text-white hover:bg-brand-deep active:bg-brand-deep/95",
        secondary:
          "border-2 border-brand-deep bg-transparent text-brand-deep hover:bg-brand-deep hover:text-white active:bg-brand-deep/95",
        outlineWhite:
          "border-2 border-white bg-transparent text-white hover:bg-white hover:text-brand-deep active:bg-white/95",
      },
      size: {
        default: "px-8 py-4",
        sm: "px-5 py-2.5",
        lg: "px-10 py-5 text-base",
      },
      fullWidth: {
        true: "w-full",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  }
);

export type Button3DVariant = VariantProps<typeof button3DVariants>["variant"];
export type Button3DSize = VariantProps<typeof button3DVariants>["size"];

export function button3DClass(
  variant?: Button3DVariant,
  size?: Button3DSize,
  fullWidth?: boolean,
  className?: string
) {
  return cn(button3DVariants({ variant, size, fullWidth }), className);
}
